import { Link } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import "../styles/pages/error-page.css";
import "../styles/components/action-button.css";

interface ErrorPageProps {
  error: Error;
  reset?: () => void;
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  return (
    <div className="container page-content">
      <div className="error-page">
        <AlertTriangle size={56} className="error-page__icon error-page__icon--warning" />
        <h1 className="error-page__error-code">Oops</h1>
        <h2 className="error-page__title">Something went wrong</h2>
        <p className="error-page__message">
          {error?.message || "An unexpected error occurred."}
        </p>
        <div className="error-page__actions">
          {reset && (
            <button
              className="action-button action-button--outline"
              onClick={reset}
            >
              Try again
            </button>
          )}
          <Link to="/" className="action-button action-button--primary">
            Back to Directory
          </Link>
        </div>
      </div>
    </div>
  );
}
